/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useRef, useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { generatePath, Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import parse from 'html-react-parser';
import { useConfig } from 'app/hooks';
import { Carousel, Image, Radio, Label, Modal, ModalTypical, Button } from 'app/components';
import useModal from 'app/hooks/useModal';
import BoxSlider from './BoxSlider';
import { SectionTopNext } from '../GiftcardInfo/styles';
import {
  H2Div,
  H4Div,
  SectionTop,
  Span,
  BannerImage,
  BannerImgSlider,
  BannerBottom,
  H5Div,
  H3Div,
  FullSlider,
  Ul,
  LI,
  ContentPart,
  FormSubmitPart,
  EnteredComPetition,
  Events
} from './styles';

const propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  info: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.any]),
  formData: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
  formOutput: PropTypes.array,
  isSubmitted: PropTypes.bool.isRequired,
  pdfContent: PropTypes.string.isRequired,
  film: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  eventList: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  updateFormData: PropTypes.func.isRequired,
  location: PropTypes.string.isRequired
};
const defaultProps = {
  formOutput: [],
  film: [],
  eventList: [],
  info: []
};

const CompetitionDetail = ({
  isLoggedIn,
  info,
  formData,
  formOutput,
  isSubmitted = false,
  pdfContent,
  film,
  eventList,
  updateFormData,
  location
}) => {
  const [t, i18n] = useTranslation();
  const [data, setData] = useState([{ question: "", answer: "" }]);
  const [filmsData, setFilmsData] = useState(film);
  const [isAvailable, setIsAvailable] = useState(isLoggedIn === true);
  const sliderPropsConfig = () => ({
    slidesToSlide: 1,
    arrows: true,
    responsive: {
      desktop: {
        breakpoint: {
          max: 30000,
          min: 992
        },
        items: 1
      },
      tablet: {
        breakpoint: {
          max: 992,
          min: 480
        },
        items: 1
      },
      mobile: {
        breakpoint: {
          max: 480,
          min: 0
        },
        items: 1
      }
    }
  });

  const sliderPropsConfig2 = () => ({
    slidesToSlide: 1,
    responsive: {
      desktop: {
        breakpoint: {
          max: 30000,
          min: 992
        },
        items: 3
      },
      tablet: {
        breakpoint: {
          max: 992,
          min: 480
        },
        items: 1
      },
      mobile: {
        breakpoint: {
          max: 480,
          min: 0
        },
        items: 1
      }
    }
  });

  const sliderRef = useRef(null);
  const sliderProps = useMemo(() => sliderPropsConfig(), []);
  const sliderProps2 = useMemo(() => sliderPropsConfig2(), []);
  const [isShowSuccess, showSuccess, hideSuccess] = useModal('success');
  const [totalAnswer, setTotalAnswer] = useState(0);
  const handleSubmit = (e) => {
    e.preventDefault();
    updateData(0);
  };

  const updateData = (index) => {
    if (index < data.length) {
      const payload = {
        competitionID: info?.id,
        competitionQuestion: data[index].question,
        competitionAnswer: data[index].answer,
      };
      updateFormData(payload);
      index += 1;
      setTimeout(() => {
        updateData(index);
      }, 2000);
    }
  }

  const { routes } = useConfig();
  const to = {
    pathname: generatePath(routes.login.pattern)
  };

  const pageReload = () => {
    window.location.reload()
  }

  useEffect(() => {
    const result = isLoggedIn === true;

    setIsAvailable(result);
  }, [isLoggedIn]);

  useEffect(() => {
    if (formOutput !== undefined) {
      if (formOutput[0] === 'success') {
        showSuccess();
      }
    }
  }, [formOutput]);

  const formChangeEvent = (que, ans, index) => {
    const temp = [...data];
    if (!temp[index]) {
      temp[index] = { question: "", answer: "" };
    }
    temp[index].question = que;
    temp[index].answer = ans;
    setData(temp);
  };

  useEffect(() => {
    const result = data?.map((item) => {
      if (item?.answer) {
        return item?.answer !== ''
      }
    });
    const totalAnswerCount = result?.filter(Boolean)?.length;
    setTotalAnswer(totalAnswerCount);
  }, [data]);

  const setPageLink = () => {
    const currentLoc = window.location.href;
    const id = [];

    for (let i = currentLoc.length - 1; i > 0; i--) {
      if (currentLoc[i] !== '/') {
        id.unshift(currentLoc[i]);
      } else {
        break;
      }
    }

    const paramsId = id.join('');
    const findPage = localStorage.getItem('page');

    if (findPage) {
      localStorage.removeItem('page');
      localStorage.setItem('page', `competition-detail/${paramsId}`);
    } else {
      localStorage.setItem('page', `competition-detail/${paramsId}`);
    }
  };

  // const getCheckedValue = option => {
  //   return i18n.language === 'en'
  //     ? data.competetion === option?.optionEN
  //     : data.competetion === option?.option;
  // };

  useEffect(() => {
    const uniqueAuthors = film.reduce((accumulator, current) => {
      if (!accumulator.find(item => item.id === current.id)) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);

    if (film?.length > 0) {
      setFilmsData([...uniqueAuthors]);
    }
  }, [film]);
  return (
    <>
      <SectionTop>
        <H2Div>{`${i18n.language === 'en' || i18n.language === 'en-US' ? info?.headline1EN : info?.headline1}`}</H2Div>
        <H4Div>{`${i18n.language === 'en' || i18n.language === 'en-US' ? info?.headline2EN : info?.headline2}`}</H4Div>
        <Span>{format(new Date(info?.date), 'dd.MM.yyyy')}</Span>
        <BannerImage>
          <Image src={info?.picture} className="banner-img" />
          <BannerImgSlider>
            {filmsData?.length > 0 && (
              <Carousel
                {...sliderProps}
                refEl={sliderRef}
                className="cinema-rent__carousel giftCardSliderData customCarousel"
                withCaption
              >
                {filmsData?.map((item, index) => (
                  <NavLink
                    key={index}
                    to={{
                      pathname: generatePath(routes.movieDetails.pattern, {
                        id: item?.title.replaceAll(' ', '-')
                      }),
                      search: `?date=${format(new Date(), 'yyyy-MM-dd')}&location=${location}`,
                      state: { movieId: item?.id }
                    }}
                    className="slider_img"
                  >
                    <Image src={item?.image} key={item?.id} className="banner-slider__image" />
                    <BannerBottom>
                      {t('common.to_movie', { which: `"${item?.title}"` })}
                    </BannerBottom>
                  </NavLink>
                ))}
              </Carousel>
            )}
          </BannerImgSlider>
        </BannerImage>
      </SectionTop>
      <SectionTop>
        <H5Div>
          <div className='description'>
            {i18n.language === 'en' || i18n.language === 'en-US'
              ? info?.longDescriptionEN !== null && parse(info?.longDescriptionEN)
              : info?.longDescription !== null && parse(info?.longDescription)}
          </div>
        </H5Div>
        {isAvailable === false && (
          <H3Div>
            {t('common.participate')}{' '}
            <span className="red">
              <Link to={to} onClick={setPageLink} style={{ textDecoration: 'underline' }}>
                {t('common.click_here')}
              </Link>
            </span>
          </H3Div>
        )}
      </SectionTop>
      {isAvailable && (
        <>
          {info?.questions?.length > 0 &&
            isSubmitted === false &&
            info?.questions?.map((question, index) => (
              <>
                <SectionTop key={index}>
                  {index === 0 && <H4Div>
                    {i18n.language === 'en' || i18n.language === 'en-US' ? info?.questionHeadlineEN : info?.questionHeadline}
                  </H4Div>}
                  <p>{i18n.language === 'en' || i18n.language === 'en-US' ? question?.questionEN : question?.question}</p>
                  <form
                    className="form"
                    onSubmit={e =>
                      handleSubmit(e)
                    }
                  >
                    <Ul>
                      {question?.options?.length > 0 &&
                        question?.options?.map((option, key) => (
                          <LI key={key}>
                            <Label className="cinema-rent__hall-radio">
                              <Radio
                                id={`option_${key}`}
                                name={`competetion_${index}`}
                                checked={i18n.language === 'en' || i18n.language === 'en-US' ? option?.optionEN === data[index]?.answer : option?.option === data[index]?.answer}
                                value={i18n.language === 'en' || i18n.language === 'en-US' ? option?.optionEN : option?.option}
                                onChange={(e) => formChangeEvent(i18n.language === 'en' || i18n.language === 'en-US' ? question.questionEN : question.question, e.target.value, index)}
                              />
                              {i18n.language === 'en' || i18n.language === 'en-US' ? option?.optionEN : option?.option}
                            </Label>
                          </LI>
                        ))}
                    </Ul>
                    {index === info.questions.length - 1 &&
                      <>
                        {isSubmitted === false && (
                          <>
                            <ContentPart>
                              <span>{t('common.the_leagal_process')}</span>
                              <p>{t('common.die_personlichen_daten')} </p>{' '}
                              <a
                                // href={pdfContent}
                                href={'/info/privacy-policy'}
                                className="cinema-rent__terms-link"
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {t('common.read_more')}
                              </a>
                            </ContentPart>
                            <FormSubmitPart>
                              <Button type="submit" className="register-btn" isPrimary disabled={totalAnswer !== info?.questions?.length}>
                                {t('common.submit')}
                              </Button>
                            </FormSubmitPart>
                          </>
                        )}
                      </>
                    }
                  </form>
                </SectionTop>
                <Modal
                  isSmall
                  isOpen={isShowSuccess}
                  close={() => { hideSuccess(); pageReload() }}
                  title={t('common.success')}
                >
                  <ModalTypical iconId="complete" title={t('common.reg_competition')} message="">
                    <Button style={{ width: '200px' }} isPrimary onClick={() => { hideSuccess(); pageReload() }}>
                      {t('common.ok')}
                    </Button>
                  </ModalTypical>
                </Modal>
              </>
            ))}

          {isSubmitted === true && (
            <SectionTop>
              <EnteredComPetition>{t('common.already_entered')}</EnteredComPetition>
            </SectionTop>
          )}
        </>
      )}
      <SectionTopNext>
        {eventList?.length > 0 && (
          <FullSlider>
            <Events> {t('common.event_title')}</Events>
            <Carousel
              {...sliderProps2}
              refEl={sliderRef}
              className="cinema-rent__carousel giftCardSliderData"
            >
              {eventList?.map(item => <BoxSlider key={item?.id} item={item} />)}
            </Carousel>
          </FullSlider>
        )}
      </SectionTopNext>
    </>
  );
};

CompetitionDetail.propTypes = propTypes;
CompetitionDetail.defaultProps = defaultProps;

export default CompetitionDetail;
